// 发货记录相关接口
import request from "@/utils/request";

// 获取发货记录
export function getList(params) {
  const { page: current, limit: size, sort, sortProp, ...otherWhere } = params;
  const whereKey = "lk_sr.";
  const payload = {
    page: {
      current,
      size,
    },
    where: Object.entries(otherWhere).reduce(
      (where, [name, value]) => ((where[whereKey + name] = value), where),
      {}
    ),
  };
  if (sort) {
    let value = "";
    if (sort === "ascending") value += "asc_sr";
    if (sort === "descending") value += "desc_sr";
    if (value) {
      value += "." + sortProp;
      payload.where[value] = 1;
    }
  } else {
    payload.where["asc_sr.createTime"] = "1";
  }
  return request.post("/ship/getPage", payload);
}

// 根据编号获取发货记录
export function findBySingleNo(singleNo) {
  return request.post("/ship/findBySingleNo/" + singleNo);
}

// 更新发货记录
export function update(data) {
  return request.post("/ship/updateRecord", data);
}

// 发送签收短信
export function sendShipMsg(data) {
  return request.post("/ship/sendShipMsg/" + data.id);
}

// 根据编号获取车辆行驶轨迹
export function moveTrackBySingleNo(singleNo) {
  return request.post("/moveTrack/findBySingleNo/" + singleNo);
}

// 删除车辆行驶轨迹
export function delMoveTrack(data) {
  return request.post("/moveTrack/deleteBySingleNos", data);
}

// 获取车辆发货记录及轨迹
export function findRecordAndTrackBySingleNo(singleNo) {
  return request.post(`/ext/ship/findRecordAndTrackBySingleNo/${singleNo}`);
}

// 确认签收货物
export function confirmSignRecipt(payload) {
  return request.post(`/ext/ship/confirmSignRecipt`, payload);
}
